const tsUniqueName = {
  zeropark: 'ZeroPark',
  clickadu: 'ClickAdu',
  exoclick: 'ExoClick',
  plugrush: 'PlugRush',
  popads: 'PopAds',
  popcash: 'PopCash',
  propeller: 'Propeller',
  hilltopads: 'HillTopAds',
  rtxpops: 'RtxPops',
  richpush: 'RichPush',
  pushground: 'PushGround',
  activerevenuemobile: 'ActiveRevenueMobile',
  evadav: 'Evadav',
  adsterra: 'Adsterra',
  ezmob: 'EzMob',
  admaven: 'AdMaven',
  kadam: 'Kadam',
  bidvertiser: 'BidVertiser',
};

const allTsTypes = Object.values(tsUniqueName);

const limits = {
  min_bid: 0,
  max_bid: 0.5,
  min_budget: 0,
  max_budget: 500,
  max_bid_percent: 500,
};

const route = {
  name: 'New Rule',
};

// Read only
const ruleTypes = {
  campaign_pause: {
    level: 'Campaign',
    rule_action: 'pause',
    to: { name: route.name, query: { type: 'campaign_pause' } },
    content: 'Pause Campaign',
    ts_types: allTsTypes,
    components: {
      name: { active: true, value: '' },
      groups: { active: true, value: [] },
      interval: { active: true, value: { input: '', interval_exclude: '0' } },
      conditions: { active: true, value: [] },
      campaigns: { active: true, value: [] },
      rotation: { active: true, value: '' },
      alert: { active: true, value: '2' },
    },
  },
  campaign_start: {
    level: 'Campaign',
    rule_action: 'start',
    to: { name: route.name, query: { type: 'campaign_start' } },
    content: 'Activate Campaign',
    ts_types: allTsTypes,
    components: {
      name: { active: true, value: '' },
      groups: { active: true, value: [] },
      interval: { active: true, value: { input: '', interval_exclude: '0' } },
      conditions: { active: true, value: [] },
      campaigns: { active: true, value: [] },
      rotation: { active: true, value: '' },
      alert: { active: true, value: '2' },
    },
  },
  campaign_change_bid: {
    level: 'Campaign',
    rule_action: 'change_bid',
    to: { name: route.name, query: { type: 'campaign_change_bid' } },
    content: 'Change Campaign Bid',
    ts_types: [tsUniqueName.zeropark, tsUniqueName.pushground, tsUniqueName.popcash, tsUniqueName.hilltopads, tsUniqueName.exoclick, tsUniqueName.clickadu, tsUniqueName.rtxpops, tsUniqueName.richpush, tsUniqueName.activerevenuemobile, tsUniqueName.evadav, tsUniqueName.ezmob, tsUniqueName.admaven, tsUniqueName.kadam, tsUniqueName.bidvertiser],
    components: {
      name: { active: true, value: '' },
      groups: { active: true, value: [] },
      interval: { active: true, value: { input: '', interval_exclude: '0' } },
      conditions: { active: true, value: [] },
      campaigns: { active: true, value: [] },
      rotation: { active: true, value: '' },
      alert: { active: true, value: '2' },
      applyToCountryBids: { active: true, value: [] },
      bid: {
        active: true,
        template: 'classic',
        value: { action: 'set', unit: 'static', to: '', value: '', min: '', max: '' },
        limits: {
          step: '0.0001',
          min: limits.min_bid,
          max: limits.max_bid,
        },
      },
    },
  },
  campaign_change_bid_cpc: {
    level: 'Campaign',
    rule_action: 'change_bid_cpc',
    to: { name: route.name, query: { type: 'campaign_change_bid_cpc' } },
    content: 'Change Campaign Bid (CPC)',
    ts_types: [tsUniqueName.propeller],
    components: {
      name: { active: true, value: '' },
      groups: { active: true, value: [] },
      interval: { active: true, value: { input: '', interval_exclude: '0' } },
      conditions: { active: true, value: [] },
      campaigns: { active: true, value: [] },
      rotation: { active: true, value: '' },
      alert: { active: true, value: '2' },
      applyToCountryBids: { active: true, value: [] },
      bid: {
        active: true,
        template: 'classic',
        value: { action: 'set', unit: 'static', to: '', value: '', min: '', max: '' },
        limits: {
          step: '0.0001',
          min: limits.min_bid,
          max: limits.max_bid,
        },
      },
    },
  },
  campaign_change_bid_cpm: {
    level: 'Campaign',
    rule_action: 'change_bid_cpm',
    to: { name: route.name, query: { type: 'campaign_change_bid_cpm' } },
    content: 'Change Campaign Bid (CPM)',
    ts_types: [tsUniqueName.propeller],
    components: {
      name: { active: true, value: '' },
      groups: { active: true, value: [] },
      interval: { active: true, value: { input: '', interval_exclude: '0' } },
      conditions: { active: true, value: [] },
      campaigns: { active: true, value: [] },
      rotation: { active: true, value: '' },
      alert: { active: true, value: '2' },
      applyToCountryBids: { active: true, value: [] },
      bid: {
        active: true,
        template: 'classic',
        value: { action: 'set', unit: 'static', to: '', value: '', min: '', max: '' },
        limits: {
          step: '0.0001',
          min: limits.min_bid,
          max: limits.max_bid,
        },
      },
    },
  },
  campaign_change_cpm: {
    level: 'Campaign',
    rule_action: 'change_cpm',
    to: { name: route.name, query: { type: 'campaign_change_cpm' } },
    content: 'Change Campaign Bid (CPM)',
    ts_types: [tsUniqueName.propeller],
    components: {
      name: { active: true, value: '' },
      groups: { active: true, value: [] },
      interval: { active: true, value: { input: '', interval_exclude: '0' } },
      conditions: { active: true, value: [] },
      campaigns: { active: true, value: [] },
      rotation: { active: true, value: '' },
      alert: { active: true, value: '2' },
      applyToCountryBids: { active: true, value: [] },
      bid: {
        active: true,
        template: 'cpm',
        value: { action: 'set', unit: 'static', to: '', value: '', min: '', max: '' },
        limits: {
          step: '0.0001',
          min: limits.min_bid,
          max: limits.max_bid,
        },
      },
    },
  },
  campaign_change_budget: {
    level: 'Campaign',
    rule_action: 'change_budget',
    to: { name: route.name, query: { type: 'campaign_change_budget' } },
    content: 'Change Campaign Budget',
    ts_types: [tsUniqueName.propeller, tsUniqueName.pushground, tsUniqueName.popcash, tsUniqueName.clickadu, tsUniqueName.rtxpops, tsUniqueName.richpush, tsUniqueName.activerevenuemobile, tsUniqueName.evadav, tsUniqueName.ezmob, tsUniqueName.admaven, tsUniqueName.kadam, tsUniqueName.bidvertiser],
    components: {
      name: { active: true, value: '' },
      groups: { active: true, value: [] },
      interval: { active: true, value: { input: '', interval_exclude: '0' } },
      conditions: { active: true, value: [] },
      campaigns: {
        active: true,
        value: [],
      },
      rotation: { active: true, value: '' },
      alert: { active: true, value: '2' },
      budget: {
        active: true,
        template: 'classic',
        value: { action: 'set', unit: 'static', to: '', value: '', min: '', max: '' },
        limits: {
          step: '0.01',
          min: limits.min_budget,
          max: limits.max_budget,
        },
      },
    },
  },
  publisher_pause: {
    level: 'Publisher',
    rule_action: 'pause',
    to: { name: route.name, query: { type: 'publisher_pause' } },
    content: 'Block Publishers',
    ts_types: [tsUniqueName.zeropark, tsUniqueName.pushground, tsUniqueName.propeller, tsUniqueName.popcash, tsUniqueName.hilltopads, tsUniqueName.exoclick, tsUniqueName.clickadu, tsUniqueName.rtxpops, tsUniqueName.richpush, tsUniqueName.activerevenuemobile, tsUniqueName.popads, tsUniqueName.plugrush, tsUniqueName.adsterra, tsUniqueName.ezmob, tsUniqueName.admaven, tsUniqueName.kadam, tsUniqueName.bidvertiser],
    components: {
      name: { active: true, value: '' },
      groups: { active: true, value: [] },
      interval: { active: true, value: { input: '', interval_exclude: '0' } },
      conditions: { active: true, value: [], 'v-validate': { no_alone_scheduler: true }, except: ['totalBudget', 'dailyBudget', 'bid'] },
      campaigns: { active: true, value: [] },
      rotation: { active: true, value: '' },
      alert: { active: true, value: '2' },
    },
  },
  publisher_start: {
    level: 'Publisher',
    rule_action: 'start',
    to: { name: route.name, query: { type: 'publisher_start' } },
    content: 'Un-Block Publishers',
    ts_types: [tsUniqueName.zeropark, tsUniqueName.pushground, tsUniqueName.propeller, tsUniqueName.popcash, tsUniqueName.hilltopads, tsUniqueName.exoclick, tsUniqueName.clickadu, tsUniqueName.rtxpops, tsUniqueName.richpush, tsUniqueName.activerevenuemobile, tsUniqueName.popads, tsUniqueName.plugrush, tsUniqueName.adsterra, tsUniqueName.ezmob, tsUniqueName.admaven, tsUniqueName.kadam, tsUniqueName.bidvertiser],
    components: {
      name: { active: true, value: '' },
      groups: { active: true, value: [] },
      interval: { active: true, value: { input: '', interval_exclude: '0' } },
      conditions: { active: true, value: [], 'v-validate': { no_alone_scheduler: true }, except: ['totalBudget', 'dailyBudget', 'bid'] },
      campaigns: { active: true, value: [] },
      rotation: { active: true, value: '' },
      alert: { active: true, value: '2' },
    },
  },
  publisher_change_bid: {
    level: 'Publisher',
    rule_action: 'change_bid',
    to: { name: route.name, query: { type: 'publisher_change_bid' } },
    content: 'Change Publisher Bid',
    ts_types: [tsUniqueName.zeropark, tsUniqueName.rtxpops, tsUniqueName.propeller, tsUniqueName.pushground, tsUniqueName.activerevenuemobile, tsUniqueName.ezmob, tsUniqueName.admaven, tsUniqueName.kadam, tsUniqueName.bidvertiser],
    components: {
      name: { active: true, value: '' },
      groups: { active: true, value: [] },
      interval: { active: true, value: { input: '', interval_exclude: '0' } },
      conditions: { active: true, value: [], 'v-validate': { no_alone_scheduler: true }, except: ['totalBudget', 'dailyBudget', 'bid'] },
      campaigns: { active: true, value: [] },
      rotation: { active: true, value: '' },
      alert: { active: true, value: '2' },
      bid: {
        active: true,
        template: 'classic',
        value: { action: 'set', unit: 'static', to: '', value: '', min: '', max: '' },
        limits: {
          step: '0.0001',
          min: limits.min_bid,
          max: limits.max_bid,
        },
      },
    },
  },
  creative_pause: {
    level: 'Creative',
    rule_action: 'pause',
    to: { name: route.name, query: { type: 'creative_pause' } },
    content: 'Pause Creative',
    ts_types: [tsUniqueName.zeropark, tsUniqueName.propeller, tsUniqueName.richpush, tsUniqueName.activerevenuemobile, tsUniqueName.ezmob, tsUniqueName.admaven, tsUniqueName.kadam],
    components: {
      name: { active: true, value: '' },
      groups: { active: true, value: [] },
      interval: { active: true, value: { input: '', interval_exclude: '0' } },
      conditions: { active: true, value: [], 'v-validate': { no_alone_scheduler: true }, except: ['totalBudget', 'dailyBudget', 'bid'] },
      campaigns: { active: true, value: [] },
      rotation: { active: true, value: '' },
      alert: { active: true, value: '2' },
    },
  },
  creative_start: {
    level: 'Creative',
    rule_action: 'start',
    to: { name: route.name, query: { type: 'creative_start' } },
    content: 'Activate Creatives',
    ts_types: [tsUniqueName.zeropark, tsUniqueName.propeller, tsUniqueName.richpush, tsUniqueName.activerevenuemobile, tsUniqueName.ezmob, tsUniqueName.admaven, tsUniqueName.kadam],
    components: {
      name: { active: true, value: '' },
      groups: { active: true, value: [] },
      interval: { active: true, value: { input: '', interval_exclude: '0' } },
      conditions: { active: true, value: [], 'v-validate': { no_alone_scheduler: true }, except: ['totalBudget', 'dailyBudget', 'bid'] },
      campaigns: { active: true, value: [] },
      rotation: { active: true, value: '' },
      alert: { active: true, value: '2' },
    },
  },
  zpsource_pause: {
    level: 'ZPSource',
    rule_action: 'pause',
    to: { name: route.name, query: { type: 'zpsource_pause' } },
    content: 'Pause Source',
    ts_types: [tsUniqueName.zeropark, tsUniqueName.pushground, tsUniqueName.richpush, tsUniqueName.activerevenuemobile, tsUniqueName.evadav, tsUniqueName.ezmob, tsUniqueName.admaven],
    components: {
      name: { active: true, value: '' },
      groups: { active: true, value: [] },
      interval: { active: true, value: { input: '', interval_exclude: '0' } },
      conditions: { active: true, value: [], 'v-validate': { no_alone_scheduler: true }, except: ['totalBudget', 'dailyBudget', 'bid'] },
      campaigns: { active: true, value: [] },
      rotation: { active: true, value: '' },
      alert: { active: true, value: '2' },
    },
  },
  zpsource_start: {
    level: 'ZPSource',
    rule_action: 'start',
    to: { name: route.name, query: { type: 'zpsource_start' } },
    content: 'Activate Source',
    ts_types: [tsUniqueName.zeropark, tsUniqueName.pushground, tsUniqueName.richpush, tsUniqueName.activerevenuemobile, tsUniqueName.evadav, tsUniqueName.ezmob, tsUniqueName.admaven],
    components: {
      name: { active: true, value: '' },
      groups: { active: true, value: [] },
      interval: { active: true, value: { input: '', interval_exclude: '0' } },
      conditions: { active: true, value: [], 'v-validate': { no_alone_scheduler: true }, except: ['totalBudget', 'dailyBudget', 'bid'] },
      campaigns: { active: true, value: [] },
      rotation: { active: true, value: '' },
      alert: { active: true, value: '2' },
    },
  },
  zpsource_change_bid: {
    level: 'ZPSource',
    rule_action: 'change_bid',
    to: { name: route.name, query: { type: 'zpsource_change_bid' } },
    content: 'Change Source Bid',
    ts_types: [tsUniqueName.zeropark, tsUniqueName.pushground],
    components: {
      name: { active: true, value: '' },
      groups: { active: true, value: [] },
      interval: { active: true, value: { input: '', interval_exclude: '0' } },
      conditions: { active: true, value: [], 'v-validate': { no_alone_scheduler: true }, except: ['totalBudget', 'dailyBudget', 'bid'] },
      campaigns: { active: true, value: [] },
      rotation: { active: true, value: '' },
      alert: { active: true, value: '2' },
      bid: {
        active: true,
        template: 'classic',
        value: { action: 'set', unit: 'static', to: '', value: '', min: '', max: '' },
        limits: {
          step: '0.0001',
          min: limits.min_bid,
          max: limits.max_bid,
        },
      },
    },
  },
  keyword_pause: {
    level: 'Keyword',
    rule_action: 'pause',
    to: { name: route.name, query: { type: 'keyword_pause' } },
    content: 'Pause Keyword',
    ts_types: [tsUniqueName.zeropark],
    components: {
      name: { active: true, value: '' },
      groups: { active: true, value: [] },
      interval: { active: true, value: { input: '', interval_exclude: '0' } },
      conditions: { active: true, value: [], 'v-validate': { no_alone_scheduler: true }, except: ['totalBudget', 'dailyBudget', 'bid'] },
      campaigns: { active: true, value: [] },
      rotation: { active: true, value: '' },
      alert: { active: true, value: '2' },
    },
  },
  keyword_start: {
    level: 'Keyword',
    rule_action: 'start',
    to: { name: route.name, query: { type: 'keyword_start' } },
    content: 'Activate Keyword',
    ts_types: [tsUniqueName.zeropark],
    components: {
      name: { active: true, value: '' },
      groups: { active: true, value: [] },
      interval: { active: true, value: { input: '', interval_exclude: '0' } },
      conditions: { active: true, value: [], 'v-validate': { no_alone_scheduler: true }, except: ['totalBudget', 'dailyBudget', 'bid'] },
      campaigns: { active: true, value: [] },
      rotation: { active: true, value: '' },
      alert: { active: true, value: '2' },
    },
  },
  keyword_change_bid: {
    level: 'Keyword',
    rule_action: 'change_bid',
    to: { name: route.name, query: { type: 'keyword_change_bid' } },
    content: 'Change Keyword Bid',
    ts_types: [tsUniqueName.zeropark],
    components: {
      name: { active: true, value: '' },
      groups: { active: true, value: [] },
      interval: { active: true, value: { input: '', interval_exclude: '0' } },
      conditions: { active: true, value: [], 'v-validate': { no_alone_scheduler: true }, except: ['totalBudget', 'dailyBudget', 'bid'] },
      campaigns: { active: true, value: [] },
      rotation: { active: true, value: '' },
      alert: { active: true, value: '2' },
      bid: {
        active: true,
        template: 'classic',
        value: { action: 'set', unit: 'static', to: '', value: '', min: '', max: '' },
        limits: {
          step: '0.0001',
          min: limits.min_bid,
          max: limits.max_bid,
        },
      },
    },
  },
  rtxchannel_pause: {
    level: 'RtxChannel',
    rule_action: 'pause',
    to: { name: route.name, query: { type: 'rtxchannel_pause' } },
    content: 'Pause RtxPops Channel',
    ts_types: [tsUniqueName.rtxpops],
    components: {
      name: { active: true, value: '' },
      groups: { active: true, value: [] },
      interval: { active: true, value: { input: '', interval_exclude: '0' } },
      conditions: { active: true, value: [], 'v-validate': { no_alone_scheduler: true }, except: ['totalBudget', 'dailyBudget', 'bid'] },
      campaigns: { active: true, value: [] },
      rotation: { active: true, value: '' },
      alert: { active: true, value: '2' },
    },
  },
  rtxchannel_start: {
    level: 'RtxChannel',
    rule_action: 'start',
    to: { name: route.name, query: { type: 'rtxchannel_start' } },
    content: 'Activate RtxPops Channel',
    ts_types: [tsUniqueName.rtxpops],
    components: {
      name: { active: true, value: '' },
      groups: { active: true, value: [] },
      interval: { active: true, value: { input: '', interval_exclude: '0' } },
      conditions: { active: true, value: [], 'v-validate': { no_alone_scheduler: true }, except: ['totalBudget', 'dailyBudget', 'bid'] },
      campaigns: { active: true, value: [] },
      rotation: { active: true, value: '' },
      alert: { active: true, value: '2' },
    },
  },
  rtxdomain_pause: {
    level: 'RtxDomain',
    rule_action: 'pause',
    to: { name: route.name, query: { type: 'rtxdomain_pause' } },
    content: 'Pause RtxPops Domain',
    ts_types: [tsUniqueName.rtxpops],
    components: {
      name: { active: true, value: '' },
      groups: { active: true, value: [] },
      interval: { active: true, value: { input: '', interval_exclude: '0' } },
      conditions: { active: true, value: [], 'v-validate': { no_alone_scheduler: true }, except: ['totalBudget', 'dailyBudget', 'bid'] },
      campaigns: { active: true, value: [] },
      rotation: { active: true, value: '' },
      alert: { active: true, value: '2' },
    },
  },
  rtxdomain_start: {
    level: 'RtxDomain',
    rule_action: 'start',
    to: { name: route.name, query: { type: 'rtxdomain_start' } },
    content: 'Activate RtxPops Domain',
    ts_types: [tsUniqueName.rtxpops],
    components: {
      name: { active: true, value: '' },
      groups: { active: true, value: [] },
      interval: { active: true, value: { input: '', interval_exclude: '0' } },
      conditions: { active: true, value: [], 'v-validate': { no_alone_scheduler: true }, except: ['totalBudget', 'dailyBudget', 'bid'] },
      campaigns: { active: true, value: [] },
      rotation: { active: true, value: '' },
      alert: { active: true, value: '2' },
    },
  },
  rtxsubid_pause: {
    level: 'RtxSubId',
    rule_action: 'pause',
    to: { name: route.name, query: { type: 'rtxsubid_pause' } },
    content: 'Pause RtxPops SubId',
    ts_types: [tsUniqueName.rtxpops],
    components: {
      name: { active: true, value: '' },
      groups: { active: true, value: [] },
      interval: { active: true, value: { input: '', interval_exclude: '0' } },
      conditions: { active: true, value: [], 'v-validate': { no_alone_scheduler: true }, except: ['totalBudget', 'dailyBudget', 'bid'] },
      campaigns: { active: true, value: [] },
      rotation: { active: true, value: '' },
      alert: { active: true, value: '2' },
    },
  },
  rtxsubid_start: {
    level: 'RtxSubId',
    rule_action: 'start',
    to: { name: route.name, query: { type: 'rtxsubid_start' } },
    content: 'Activate RtxPops SubId',
    ts_types: [tsUniqueName.rtxpops],
    components: {
      name: { active: true, value: '' },
      groups: { active: true, value: [] },
      interval: { active: true, value: { input: '', interval_exclude: '0' } },
      conditions: { active: true, value: [], 'v-validate': { no_alone_scheduler: true }, except: ['totalBudget', 'dailyBudget', 'bid'] },
      campaigns: { active: true, value: [] },
      rotation: { active: true, value: '' },
      alert: { active: true, value: '2' },
    },
  },
  campaign_day_parting: {
    level: 'Campaign',
    rule_action: 'day_parting',
    to: { name: route.name, query: { type: 'campaign_day_parting' } },
    content: 'Day Parting',
    ts_types: allTsTypes,
    components: {
      name: { active: true, value: '' },
      groups: { active: true, value: [] },
      conditions: { active: true, value: [{ hour_of_day: { condition: '', value: '' } }], hour_of_day: true, disable_buttons: true, filter_fields: ['hour_of_day'] },
      campaigns: { active: true, value: [] },
      rotation: { active: true, value: '0.16', disabled: true, hide: true },
      alert: { active: true, value: '2' },
      campaign_action: { active: true, value: { valid: 'start', otherwise: 'pause' } },
    },
  },
};

const enabledTypes = [
  ruleTypes.campaign_pause,
  ruleTypes.campaign_start,
  ruleTypes.campaign_change_bid,
  ruleTypes.campaign_change_bid_cpc,
  ruleTypes.campaign_change_bid_cpm,
  ruleTypes.campaign_change_budget,
  ruleTypes.publisher_start,
  ruleTypes.publisher_pause,
  ruleTypes.publisher_change_bid,
  ruleTypes.creative_start,
  ruleTypes.creative_pause,
  ruleTypes.zpsource_start,
  ruleTypes.zpsource_pause,
  ruleTypes.zpsource_change_bid,
  ruleTypes.keyword_start,
  ruleTypes.keyword_pause,
  ruleTypes.keyword_change_bid,
  ruleTypes.rtxchannel_start,
  ruleTypes.rtxchannel_pause,
  ruleTypes.rtxdomain_start,
  ruleTypes.rtxdomain_pause,
  ruleTypes.rtxsubid_start,
  ruleTypes.rtxsubid_pause,
  ruleTypes.campaign_day_parting,
];

module.exports = { ruleTypes, enabledTypes };
